<template>
  <section>
    <h1 class="text-h3 mb-8">
      File inputs
    </h1>
    <h2 class="text-h4 mb-4">
      Basic style
    </h2>
    <v-container>
      <v-row
        v-for="i in 2"
        :key="i"
      >
        <v-col>
          <v-file-input
            v-model="value[i]"
            :label="(i === 1 ? 'Filled' : 'Outlined') + ' file input'"
            :filled="i === 1"
            :outlined="i === 2"
            hint="A hint for the file input."
            persistent-hint
            clearable
          />
        </v-col>
        <v-col>
          <v-file-input
            v-model="value[i]"
            :label="(i === 1 ? 'Filled' : 'Outlined') + ' file input'"
            :filled="i === 1"
            :outlined="i === 2"
            error-messages="A error message for the file input."
            error
            clearable
          />
        </v-col>
        <v-col>
          <v-file-input
            v-model="value[i]"
            :label="(i === 1 ? 'Filled' : 'Outlined') + ' file input'"
            :filled="i === 1"
            :outlined="i === 2"
            hint="A hint for the file input."
            persistent-hint
            clearable
            disabled
          />
        </v-col>
      </v-row>
    </v-container>
    <h2 class="text-h4 mb-4">
      Custom style
    </h2>
    <p>Add <code>.custom-append-inner</code> class to add flex style instead of default append slot style to create more flexibility.</p>
    <v-file-input
      ref="fileInput"
      class="custom-append-inner"
      label="Select your avatar file"
      placeholder="No file selected"
      truncate-length="99"
      prepend-icon=""
      persistent-placeholder
      outlined
    >
      <template #append>
        <v-btn
          color="primary"
          depressed
          @click="openBrowseDialog"
        >
          Browse
        </v-btn>
      </template>
    </v-file-input>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/components/file-inputs/">
      <strong>File inputs</strong>
    </external-link>
  </section>
</template>

<script>
export default {
  name: 'FormFileInputs',
  data: () => ({
    value: {
      1: null,
      2: null
    }
  }),
  methods: {
    openBrowseDialog () {
      this.$refs.fileInput.$refs.input.click()
    }
  }
}
</script>
